import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.25",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.938 6.688H3.061a.875.875 0 0 0-.874.875v6.125c0 .483.391.874.874.874h7.876a.875.875 0 0 0 .874-.874V7.561a.875.875 0 0 0-.874-.875Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M3.938 6.688V4.5a3.062 3.062 0 0 1 6.124 0v2.188M7 9.75v1.75" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }